export default {
  // computed: {
  //   lang() {
  //     return this.$store.state.app.language
  //   }
  // },
  // watch: {
  //   lang() {
  //     this.chart.setOption(this.options, true)
  //   }
  // }
}
